var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-icon"},[_c('img',{attrs:{"src":_vm.$data[_vm.grade]}})])
}
var staticRenderFns = []

export { render, staticRenderFns }